<template>
  <div class="home" :class="{'horizontal': isHorizontal, 'safe-content': isHorizontal && isHasSafeLeft}">
    <!-- 底部背景 -->
    <div class="h5-loading-cover quwanwan-cover" style="display: block;" v-if="showLoadingCover">
      <img v-if="isInit" :src="require(`@/assets/img/${theme[init.ui_type].imgUrl}/loading_cover.jpg`)">
      <img v-else :src="require(`@/assets/img/blue/loading_cover.jpg`)">
    </div>

    <!-- 悬浮框 -->
    <div class="am-btn" v-show="token && $route.query.g_token && isInit && init.float_window_display" @click="open = !open" ref="am">
      <img v-if="(init.ui_type === 4 || init.ui_type === 5) && init.event_info && init.event_info.status" :src="init.event_info.icon" alt="">
      <img v-else :src="require(`@/assets/img/${theme[init.ui_type].imgUrl}/icon-fg_t.png`)">
      <em class="qiwanwansdk_fuli" style="display: inline;">礼包</em>
    </div>

    <mu-drawer v-if="init.ui_type !== 4 && init.ui_type !== 5" :open.sync="open" :docked="docked" :right="position === 'right'" width="85%">
      <draw-index :realName="isRealName || goRealNameRoute" :bindPhoneStatus="isBindPhone" />
    </mu-drawer>

    <!-- 红包版弹窗信息框 -->
    <mu-dialog class="mudia" v-if="init.ui_type === 4 || init.ui_type === 5" :padding="20" width="360" scrollable :open.sync="open" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_user">
          <div class="avatar">
            <img :src="status.avatar">
          </div>
          <span class="md_username">{{status.user_name}}</span>
        </div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="open = !open"></mu-icon>
      </div>
      <div class="md_content">
        <hd-draw-index :realName="isRealName || goRealNameRoute" :bindPhoneStatus="isBindPhone" />
      </div>
    </mu-dialog>

    <!-- 游戏容器 -->
    <iframe ref="game_iframe" class="h5-game-iframe" :class="isIOSBangs() && (init.identity === 1797 || init.identity === 2483 || init.identity === 2599) && !isHorizontal ? 'bangsTop' : ''" scrolling="no" allowtransparency="yes" name="game-frame"
        :src="gameUrl" frameborder="no" :style="`width: ${iframeWidth}px; height: ${iframeHeight}px;`">
    </iframe>

    <!-- 登陆注册弹窗 -->
    <template v-if="init.ui_type === 3">
      <mu-dialog :open.sync="openSimple" max-width="340px" width="90%" :overlay-close="false" v-show="!token && init.ui_type === 3">
        <p class="dl-title" slot="title" v-if="loginType === 'user'">账号登录</p>
        <p class="dl-title" slot="title" v-if="loginType === 'phone'">手机登录</p>
        <p class="dl-title" slot="title" v-if="loginType === 'register'">账号注册</p>
        <p class="dl-title" slot="title" v-if="loginType === 'reset'">
          重设密码
          <mu-icon value="keyboard_arrow_left" class="back-icon" @click="switchLoginType('user')"></mu-icon>
        </p>
        <div class="dia-content-box">
          <div class="user" v-if="loginType === 'user' || loginType === 'register'">
            <mu-form :model="loginPhoneForm" class="mu-demo-form">
              <mu-text-field full-width icon="account_circle" v-if="loginType === 'register'" :underline-color="themeConfig.dark" :color="themeConfig.dark" v-model="loginPhoneForm.username" placeholder="请输入账号"></mu-text-field>
              <mu-auto-complete full-width :max-height="200" :data="userInputList" v-if="loginType === 'user'" :underline-color="themeConfig.dark" :color="themeConfig.dark" icon="account_circle" :max-search-results="10"  v-model="loginPhoneForm.username" open-on-focus placeholder="请输入账号" @select="selectUser" />
              <mu-text-field full-width icon="locked" :underline-color="themeConfig.dark" :color="themeConfig.dark" :action-icon="visibility ? 'visibility_off' : 'visibility'" :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'" v-model="loginPhoneForm.password" placeholder="请输入密码"></mu-text-field>
              <div class="check-box">
                <mu-checkbox :color="themeConfig.dark" v-model="check"></mu-checkbox>
                <span class="check-p">我已阅读并同意<a @click="userContentCheck" :style="`color: ${themeConfig.dark}`">用户协议及隐私协议</a></span>
              </div>
              <mu-button full-width :color="themeConfig.dark" v-if="loginType === 'user'" @click="login('ACCOUNT')" v-loading="adminLoading">马上登录</mu-button>
              <mu-button full-width :color="themeConfig.dark" v-if="loginType === 'register'" @click="getRegister" v-loading="registerLoading">马上注册</mu-button>
              <p class="tar" v-if="loginType === 'user'">
                <span class="reset" @click="switchLoginType('reset')">忘记密码?</span>
                <!-- 暂时取消注册功能 -->
                <span :style="`color: ${themeConfig.dark}`" v-if="init.ui_type !== 3" @click="switchLoginType('register')">注册帐号</span>
              </p>
              <div class="tar" v-if="loginType === 'register'">
                <p class="back">已有账号？<span @click="switchLoginType('user')" :style="`color: ${themeConfig.dark}`">登录</span></p>
                <span :style="`color: ${themeConfig.dark}`" @click="quickRegister" v-loading="qsLoading">一键注册</span>
              </div>
            </mu-form>
          </div>
          <div class="phone" v-if="loginType === 'phone'">
            <mu-form :model="phoneForm" class="mu-demo-form">
              <mu-text-field full-width icon="phone" type="number" :color="themeConfig.dark" :underline-color="themeConfig.dark" v-model="phoneForm.phone" placeholder="请输入手机号码"></mu-text-field>
              <mu-text-field full-width icon="verified_user" type="number" :underline-color="themeConfig.dark" :color="themeConfig.dark" v-model="phoneForm.code" placeholder="请输入验证码">
                <mu-button :disabled="codeDisabled" class="code" append flat :color="themeConfig.dark" small @click="getCode">{{codeDisabled ? `${codeTime}s`: '获取验证码'}}</mu-button>
              </mu-text-field>
              <div class="check-box">
                <mu-checkbox :color="themeConfig.dark" v-model="check"></mu-checkbox>
                <span class="check-p">我已阅读并同意<a @click="userContentCheck" :style="`color: ${themeConfig.dark}`">用户协议及隐私协议</a></span>
              </div>
              <mu-button full-width :color="themeConfig.dark" @click="login('PHONE')" v-loading="adminLoading">马上登录</mu-button>
              <p class="tips">使用手机马上登录，无需注册！</p>
            </mu-form>
          </div>
          <div class="reset-user" v-if="loginType === 'reset'">
            <mu-form :model="resetForm" class="mu-demo-form">
              <mu-text-field full-width icon="account_circle" :color="themeConfig.dark" :underline-color="themeConfig.dark" v-model="resetForm.username" placeholder="请输入用户名"></mu-text-field>
              <mu-text-field full-width icon="phone" type="number" :color="themeConfig.dark" :underline-color="themeConfig.dark" v-model="resetForm.phone" placeholder="请输入手机号码"></mu-text-field>
              <mu-text-field full-width icon="verified_user" type="number" :underline-color="themeConfig.dark" :color="themeConfig.dark" v-model="resetForm.code" placeholder="请输入验证码">
                <mu-button :disabled="resetDisabled" class="code" append flat :color="themeConfig.dark" small @click="getCode('reset')">{{resetDisabled ? `${resetCodeTime}s`: '获取验证码'}}</mu-button>
              </mu-text-field>
              <mu-text-field full-width icon="locked" :underline-color="themeConfig.dark" :color="themeConfig.dark" type="password" v-model="resetForm.password" placeholder="请输入密码"></mu-text-field>
              <mu-text-field full-width icon="locked" :underline-color="themeConfig.dark" :color="themeConfig.dark" type="password" v-model="resetForm.password_confirmation" placeholder="请再次输入密码"></mu-text-field>
              <mu-button full-width :color="themeConfig.dark" v-loading="resetLoading" @click="resetSubmit">确定</mu-button>
            </mu-form>
          </div>
          <div class="fast-login" v-if="loginType !== 'reset'">
            <div class="title"><span>其他登录方式</span></div>
            <div class="flex">
              <div class="flex-item" @click="loginType = 'phone'">
                <div class="icon-box" :style=" loginType === 'phone' ? `background: ${themeConfig.dark}` : null">
                  <img :src="require('@/assets/img/Syg_icon_sj.png')">
                </div>
                <p class="flex-title" :class="loginType === 'phone' ? `color: ${themeConfig.dark}` : null">手机</p>
              </div>
              <div class="flex-item" @click="switchLoginType('user')">
                <div class="icon-box" :style=" loginType === 'user' || loginType === 'register' ? `background: ${themeConfig.dark}` : null">
                  <img v-if="init.ui_type === 1" :src="require('@/assets/img/Syg_icon_tw1.png')">
                  <img v-else :src="require('@/assets/img/Syg_icon_tw.png')">
                </div>
                <p class="flex-title" :style=" loginType === 'user' || loginType === 'register' ? `color: ${themeConfig.dark}` : null">账号</p>
              </div>
              <div class="flex-item" @click="goWx" v-if="isPC && init.ui_type === 1">
                <div class="icon-box">
                  <img :src="require('@/assets/img/Syg_icon_wx.png')">
                </div>
                <p class="flex-title">微信</p>
              </div>
            </div>
          </div>
        </div>
      </mu-dialog>
    </template>

    <!-- 新登陆注册弹窗 -->
    <template v-if="init.ui_type !== 3">
      <mu-dialog class="new-login" :open.sync="openSimple" max-width="340px" width="90%" :overlay-close="false" v-show="!token && (init.ui_type !== 3)">
        <div>
          <div class="l-title" :style="`color: ${themeConfig.dark}`">
            <p v-if="loginType === 'user'">账号登录</p>
            <p v-if="loginType === 'register'">账号注册</p>
            <p v-if="loginType === 'phone'">手机登录</p>
            <p v-if="loginType === 'reset'">忘记密码</p>
            <div class="back" v-if="loginType === 'reset'" @click="switchLoginType('user')">
              <img :src="require('@/assets/img/backIcon.png')">
            </div>
          </div>
          <div v-if="loginType === 'user' || loginType === 'register'">
            <div class="l-input" :class="loginBoxClick ? 'selcet-input' : ''">
              <div class="i-title">账  号:</div>
              <input type="text" class="input-box" @focus="loginBoxClick = false" v-model="loginPhoneForm.username" placeholder="请输入账号" />
              <span class="select-icon" @click="loginBoxClick = !loginBoxClick" v-if="loginType === 'user'">
                <img :src="require('@/assets/img/selectIcon.png')">
              </span>
              <div class="select-list" v-if="loginType === 'user'">
                <div class="item" v-for="(item, index) in userInputList" :key="index">
                  <span class="p" @click="selectUser(item)">{{item}}</span>
                  <span class="clean" @click="cleanUser(item, index)">
                    <img :src="require('@/assets/img/cleanUser.png')">
                  </span>
                </div>
              </div>
            </div>
            <div class="l-input">
              <div class="i-title">密  码:</div>
              <input :type="visibility ? 'text' : 'password'" class="input-box" v-model="loginPhoneForm.password" placeholder="请输入密码">
              <span class="select-icon" v-if="loginType === 'user'" @click="visibility = !visibility">
                <mu-icon class="icon-box" v-if="visibility" value="visibility"></mu-icon>
                <mu-icon class="icon-box" v-else value="visibility_off"></mu-icon>
              </span>
            </div>
            <div class="l-input" v-if="init.identity === 885 && loginType === 'user'">
              <div class="i-title">验证码:</div>
              <input type="text" class="input-box input-code" v-model="loginPhoneForm.code" placeholder="请输入微信验证码">
              <span class="get-code" v-if="isGetWechatCode" @click="getWechatCode('user')">获取微信验证码</span>
            </div>
            <!-- 图片验证码 -->
            <div class="l-input" v-if="loginType === 'register' && init.identity === 885">
              <div class="i-title">验证码:</div>
              <input type="text" class="input-box input-code" v-model="pictureCode" placeholder="请输入验证码">
              <div class="picture-box" @click="setIdentifyCode">
                <Indetity
                  :identifyCode="identifyCode" />
              </div>
            </div>
          </div>
          <div v-if="loginType === 'phone'">
            <div class="l-input">
              <div class="i-title">手机号:</div>
              <input type="text" maxlength="11" class="input-box" v-model="phoneForm.phone" placeholder="请输入手机号">
            </div>
            <div class="l-input">
              <div class="i-title">验证码:</div>
              <input type="text" class="input-box input-code" v-model="phoneForm.code" placeholder="请输入验证码">
              <span class="get-code" @click="getCode">{{codeDisabled ? `${codeTime}s`: '获取验证码'}}</span>
            </div>
            <div class="l-input" v-if="init.identity === 885">
              <div class="i-title">验证码:</div>
              <input type="text" class="input-box input-code" v-model="phoneForm.wechat_code" placeholder="请输入微信验证码">
              <span class="get-code" v-if="isGetWechatCode" @click="getWechatCode('phone')">获取微信验证码</span>
            </div>
          </div>
          <div v-if="loginType === 'reset'">
            <div class="l-input">
              <div class="i-title">账  号:</div>
              <input type="text" class="input-box" v-model="resetForm.username" placeholder="请输入账号">
            </div>
            <div class="l-input">
              <div class="i-title">手机号:</div>
              <input type="text" maxlength="11" class="input-box" v-model="resetForm.phone" placeholder="请输入手机号">
            </div>
            <div class="l-input">
              <div class="i-title">验证码:</div>
              <input type="text" class="input-box input-code" v-model="resetForm.code" placeholder="请输入验证码">
              <span class="get-code" @click="getCode('reset')">{{resetDisabled ? `${resetCodeTime}s`: '获取验证码'}}</span>
            </div>
            <div class="l-input">
              <div class="i-title">密  码:</div>
              <input type="password" class="input-box" v-model="resetForm.password" placeholder="请输入密码">
            </div>
            <div class="l-input">
              <div class="i-title">密  码:</div>
              <input type="password" class="input-box" v-model="resetForm.password_confirmation" placeholder="请再次输入密码">
            </div>
          </div>
          <div class="l-tips" v-if="loginType !== 'reset'">
            <div :class="loginType === 'user' ? 'tips-left' : ''">
              <span class="l-img" v-if="!check" @click="check = true"><img :src="require('@/assets/img/checkNo.png')"></span>
              <span class="l-img" v-if="check" @click="check = false"><img :src="require('@/assets/img/checkYes.png')"></span>
              <span class="p">我已阅读并同意<a @click="userContentCheck">{{loginType === 'user' ? '用户协议' : '用户协议及私隐协议'}}</a></span>
            </div>
            <span class="lose-pwd" v-if="loginType === 'user'" @click="switchLoginType('reset')">忘记密码</span>
          </div>
          <div class="l-button" :style="`background: ${themeConfig.dark}`">
            <div class="b-button" v-if="loginType === 'register'" v-loading="registerLoading" @click="getRegister">注 册</div>
            <div class="b-button" v-if="loginType === 'user'" v-loading="adminLoading" @click="login('ACCOUNT')">登 录</div>
            <div class="b-button" v-if="loginType === 'phone'" v-loading="adminLoading" @click="login('PHONE')">登 录</div>
            <div class="b-button" v-if="loginType === 'reset'" v-loading="resetLoading" @click="resetSubmit">确 认</div>
          </div>
          <div class="l-bot" v-if="loginType === 'register'">
            <span class="left" @click="switchLoginType('user')">账号登录</span>
            <span class="right" @click="switchLoginType('phone')">手机一键登录</span>
          </div>
          <div class="l-bot" v-if="loginType === 'user'">
            <span class="left" @click="switchLoginType('phone')">手机一键登录</span>
            <span class="right" @click="switchLoginType('register')">账号注册</span>
          </div>
          <div class="l-bot" v-if="loginType === 'phone'">
            <span class="left" @click="switchLoginType('user')">账号登录</span>
            <span class="right" @click="switchLoginType('register')">账号注册</span>
          </div>
        </div>
      </mu-dialog>
    </template>

    <!-- 微信二维码弹窗 -->
    <mu-dialog class="new-login" :open.sync="openWxQrCode" max-width="280px" width="90%" v-if="init.identity === 885">
      <div class="wx-img-box">
        <img class="wx-qrcode" :src="require('@/assets/img/qrcode_for_gh_84617f4b5028_258.jpg')">
        <p class="wx-tips">请扫描上方二维码，获取登录验证码</p>
      </div>
    </mu-dialog>

    <!-- 实名认证弹窗 -->
    <mu-dialog :open.sync="isRealName" max-width="300px" :overlay-close="false">
      <p class="dl-title" slot="title">温馨提示</p>
      <div class="dl-content mb20">
        <p>尊敬的用户，您好：</p>
        <p>根据文化部《互联网文化管理暂行规定》和《网络游戏管理暂行办法》相关规定，未完成实名认证的用户将不能在在游戏中进行充值，请您完成实名认证后在进行相关的充值操作。</p>
      </div>
      <div class="dl-footer">
        <mu-button :color="themeConfig.dark" full-width text-color="#fff" @click="isRealName = false">立即认证</mu-button>
      </div>
    </mu-dialog>

    <!-- 绑定手机弹窗 -->
    <mu-dialog :open.sync="isBindPhoneOpen" max-width="300px" :overlay-close="false">
      <p class="dl-title" slot="title">温馨提示</p>
      <div class="dl-content mb20">
        <p class="dl-c-title">请绑定手机号码，体验完整游戏</p>
        <p>*根据国家网络信息办公室颁布的《移动互联网应用程序信息服务管理规定》，从2016年8月1日起，互联网注册用户应当进行基于移动电话号码等真实身份信息认证。</p>
      </div>
      <div class="dl-footer">
        <mu-button :color="themeConfig.dark" full-width text-color="#fff" @click="isBindPhoneOpen = false">立即绑定</mu-button>
      </div>
    </mu-dialog>

    <!-- (iframe) -->
    <iframe class="window_iframe" :src="payUrl"></iframe>

    <!-- 新支付弹窗 -->
    <mu-dialog :padding="0" width="300px" :open.sync="payDialog">
      <div class="dialog-box" v-loading="payLoading">
          <!-- 移动支付 -->
          <div class="title-box">
            <p class="dl-title">充值中心</p>
            <mu-icon value="close" class="close" @click="closePay"></mu-icon>
          </div>
          <div class="mobile" v-if="!code_img_url">
            <div class="dl-cont">
              <p class="dl-c-title">【{{payData.server_name}}】<span>{{payData.role_name}}</span></p>
              <p class="money">¥ {{payData.money}}</p>
              <p class="money-name">{{payData.product_name}}</p>
            </div>
            <div class="dl-bot">
              <div class="dl-b-title">
                <div class="line"></div>
                <span>请选择支付方式</span>
              </div>
              <div class="btn-box">
                <mu-button class="btn" :color="themeConfig.dark" text-color="#fff" v-if="!(init.ui_type === 2 && isWeixin && init.identity !== 885)" @click="pay('wx')">微信</mu-button>
                <mu-button class="btn" :color="themeConfig.dark" text-color="#fff" v-if="!isWeixin && showAli" @click="pay('ali')">支付宝</mu-button>
              </div>
            </div>
          </div>

          <!-- 扫码支付 -->
          <div class="pc" v-if="code_img_url && isPC">
            <div class="pc-img-box">
              <img :src="code_img_url" alt="">
            </div>
            <p class="pc-title">使用<span :style="`color: ${payName === '微信' ? '#2EBE37': '#33ABFF'}`">{{payName}}</span>扫码，支付<span class="pc-money">{{payData.money}}</span>元</p>
            <a class="pc-a" :href="pay_url">点此直接支付</a>
          </div>
      </div>
    </mu-dialog>

    <!-- 心跳检测 -->
    <heartbeat ref="heartbeat" :hasHeartbeat.sync="hasHeartbeat" :rechargeObj.sync="rechargeObj" @heartbeatFunc="heartbeatFunc" />

    <!-- 提示弹窗 -->
    <model-tips :showTips.sync="showTips" :msge="msge" />

    <!-- 用户协议及隐私协议弹窗 -->
    <mu-dialog transition="slide-bottom" scrollable fullscreen :padding="0" :append-body="false" :open.sync="openFullscreen">
       <mu-appbar :color="themeConfig.dark" title="用户协议及隐私协议" class="app-bar">
          <mu-button slot="left" icon @click="openFullscreen = false">
            <mu-icon value="close"></mu-icon>
          </mu-button>
       </mu-appbar>
       <div class="user-content" v-html="userContent"></div>
    </mu-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DrawIndex from '@/views/components/DrawIndex'
import HdDrawIndex from '@/views/components/hdui/DrawIndex'
import { validate, isMobile, isIOS, isWeixin, isIOSBangs, isQQ } from '@/utils/validate'
import { getToken, setToken, setSession, moveDiv, removeToken, removeSession, newPromise, h5IosWapSdk, wx } from '@/utils'
import { sendSms, sendSms915 } from '@/api/sendSms'
import { getRegisterAccount, resetPassword } from '@/api/register'
import { twContent, content } from '@/utils/txt'
import { pay, wftWxJsPay, checkOrder, qutongWXPay, qutongAliPay, paySwitch, payApple } from '@/api/pay'
import { getWechatCode } from '@/api/getWechatCode'
import Indetity from '@/views/components/common/indetity'
import Heartbeat from '@/views/components/heartbeat'
import ModelTips from '@/views/components/common/modelTips'
import Cookies from 'js-cookie'
import NoSleep from 'nosleep.js'

const urlPath = process.env.NODE_ENV === 'production' ? '/play/' : '/'
export default {
  name: 'home',
  data () {
    return {
      showLoadingCover: true,
      adminLoading: false, //  账号密码登陆按钮loading
      registerLoading: false, //  注册按钮的loading
      qsLoading: false, //  一键注册请求loading
      resetLoading: false, // 重置密码的loading
      visibility: false, //  密码的显示隐藏
      docked: false,
      open: false,
      openFullscreen: false, //  全屏协议弹窗
      payDialog: false, //  支付窗口
      payLoading: false, //  支付点击loading
      position: 'left',
      isLogin: false,
      isPC: !isMobile(), //  是否为PC
      isWeixin: isWeixin(),
      isIOS: isIOS(),
      openSimple: false,
      check: true,
      isRealName: false, //  控制弹窗实名认证的窗口
      goRealNameRoute: false, //  跳转弹窗实名认证
      payUrl: '', //  iframe的url地址
      loginPhoneForm: { //  切换账号
        username: '',
        password: ''
      },
      phoneForm: {
        phone: '',
        code: ''
      },
      resetForm: { //  重设密码form
        username: '',
        phone: '',
        code: '',
        password: '',
        password_confirmation: ''
      },
      loginType: 'user', // user账号 phone手机 register注册 reset重设密码
      codeTime: 0, // 倒计时
      resetCodeTime: 0, //  重置倒计时
      codeDisabled: false,
      resetDisabled: false,
      iframeWidth: 0,
      iframeHeight: 0,
      gameUrl: '', //  游戏加载url
      userContent: '',
      payData: { //  支付的信息
        server_name: '', //  服务器名称
        role_name: '', //  角色名称
        money: 0, //  充值金额
        product_name: '' // 金币名称
      },
      code_img_url: '', //  支付url图片地址
      pay_url: '', //  支付url地址
      payName: '',
      order_id: '', //  订单id
      orderCount: 0, //  循环次数
      userList: [], //  获取的账号列表
      userInputList: [], // input框的账号列表
      loginBoxClick: false,
      isBindPhone: false, //  控制打开侧边栏后显示绑定页面
      sid: '', //  loadGame的一个参数
      isBindPhoneOpen: false,
      isGetWechatCode: true, //  是否可点击获取微信验证码
      openWxQrCode: false, //  微信二维码弹窗开关
      pictureCode: '', //  图片验证码输入
      identifyCode: '1234', // 生成的随机数
      hasHeartbeat: false, //  心跳检测
      rechargeObj: {}, //  充值防沉迷obj
      showTips: false,
      msge: '',
      iosSwitch: 1, // ios支付开关 1: 第三方 2：第三方+内购 3：内购
      showAli: true,
      isHasSafeLeft: false
    }
  },
  components: {
    DrawIndex,
    Indetity,
    Heartbeat,
    ModelTips,
    HdDrawIndex
  },
  computed: {
    ...mapGetters([
      'isHorizontal',
      'theme',
      'init',
      'token',
      'themeConfig',
      'isInit',
      'status',
      'idfa'
    ])
  },
  mounted () {
    if (this.$route.query.seqId && this.$route.query.connectSys) {
      window.close()
    }
    this.fullIframe()
    if (this.$route.query.g_token) {
      // 解决+号变空格的情况
      this.$route.query.g_token = this.$route.query.g_token.replace(/\s+/g, '+')
      this.$store.commit('SET_APPID', this.$route.query.g_token)
      this.getImei()
      this.getInit()
    } else {
      if (window.location.host === 'dehan168.cn') {
        this.$route.query.g_token = 'iASIxeH4K9exqN8mapgz4w=='
        this.$store.commit('SET_APPID', this.$route.query.g_token)
        this.getImei()
        this.getInit()
      } else {
        this.$toast.error({ message: '参数缺失', time: 0 })
        return
      }
    }
    moveDiv(this.$refs.am)
    this.payFunc()
    this.checkIosTraceless()
    // 如果是IOS设备
    if (isIOS()) {
      let flag = false
      let pageBackNormFunc
      // 聚焦后，键盘弹起
      document.body.addEventListener('focusin', () => {
        flag = true
        pageBackNormFunc && clearTimeout(pageBackNormFunc)
      })
      // 失焦后，键盘关闭
      document.body.addEventListener('focusout', () => {
        if (flag) {
          // 页面滚动回原来的位置
          pageBackNormFunc = setTimeout(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
          }, 200)
        }
        flag = false
      })
    }
    if (this.$route.query.isHasSafeLeft) {
      this.isHasSafeLeft = true
    }
  },
  watch: {
    codeTime (val) {
      if (val > 0) {
        setTimeout(() => {
          this.codeTime > 0 && this.codeTime--
        }, 1000)
      } else {
        this.codeDisabled = false
      }
    },
    resetCodeTime (val) {
      if (val > 0) {
        setTimeout(() => {
          this.resetCodeTime > 0 && this.resetCodeTime--
        }, 1000)
      } else {
        this.resetDisabled = false
      }
    },
    'loginPhoneForm.username': function () {
      this.isGetWechatCode = true
    },
    'phoneForm.phone': function () {
      this.isGetWechatCode = true
    }
  },
  methods: {
    // 初始显示流程
    initShow () {
      if (this.userList.length > 0) {
        if (sessionStorage.getItem('username') && sessionStorage.getItem('username') !== 'undefined') {
          const username = sessionStorage.getItem('username')
          sessionStorage.removeItem('username')
          this.selectUser(username)
          return
        }
        this.selectUser(this.userList[0].username)
        return
      }
      this.loginType = 'register'
      this.quickRegister()
    },
    // 获取设备信息
    getImei () {
      let idfa
      if (navigator.hasOwnProperty('xdevice_info')) {
        idfa = navigator.xdevice_info.idfa || this.$route.query.idfa || this.$route.query.imei || 'h5_imei'
      } else {
        idfa = this.$route.query.idfa || this.$route.query.imei || 'h5_imei'
      }
      this.$store.commit('SET_IDFA', idfa)
    },
    // 公众号登陆流程
    wxLogin () {
      if (!this.$route.query.wx_openid || !this.$route.query.sessionid) {
        window.location.href = `//${this.theme[this.init.ui_type].apiName}.com/api/wxjslogin/index.php?goto_url=${encodeURIComponent(window.location.origin + urlPath + '?g_token=' + this.$route.query.g_token)}`
      } else {
        this.login('WECHAT')
      }
    },
    // 调整iframe框全屏大小
    fullIframe () {
      var num = 0
      // 针对1797游戏处理刘海问题
      if (isIOSBangs() && (this.init.identity === 1797 || this.init.identity === 2483 || this.init.identity === 2599)) {
        num = 34
      }
      // 针对3449游戏底部不能按的问题
      if (this.init.identity === 3449) {
        num = 20
      }

      this.iframeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      this.iframeWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      this.$store.commit('SET_ISHORIZONTAL', (window.orientation === 90 || window.orientation === -90)) //  判断是否横屏
      if (!(window.orientation === 90 || window.orientation === -90)) {
        this.iframeHeight -= num
      } else {
        if (this.isHasSafeLeft) {
          if (Number(getComputedStyle(document.documentElement).getPropertyValue('--sal').replace('px', '')) > 0) {
            this.iframeWidth -= Number(getComputedStyle(document.documentElement).getPropertyValue('--sal').replace('px', ''))
          }
          if (Number(getComputedStyle(document.documentElement).getPropertyValue('--sar').replace('px', '')) > 0) {
            this.iframeWidth -= Number(getComputedStyle(document.documentElement).getPropertyValue('--sar').replace('px', ''))
          }
        }
      }
      this.$nextTick(() => {
        window.addEventListener('orientationchange', () => {
          setTimeout(() => {
            this.iframeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
            this.iframeWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            this.$store.commit('SET_ISHORIZONTAL', (window.orientation === 90 || window.orientation === -90)) //  判断是否横屏
            if (!(window.orientation === 90 || window.orientation === -90)) {
              this.iframeHeight -= num
            } else {
              if (this.isHasSafeLeft) {
                if (Number(getComputedStyle(document.documentElement).getPropertyValue('--sal').replace('px', '')) > 0) {
                  this.iframeWidth -= Number(getComputedStyle(document.documentElement).getPropertyValue('--sal').replace('px', ''))
                }
                if (Number(getComputedStyle(document.documentElement).getPropertyValue('--sar').replace('px', '')) > 0) {
                  this.iframeWidth -= Number(getComputedStyle(document.documentElement).getPropertyValue('--sar').replace('px', ''))
                }
              }
            }
            moveDiv(this.$refs.am)
          }, 350)
        })
      })
    },
    //  跳转到实名认证
    goRealName () {
      this.isRealName = true
      this.open = true
    },
    goBindPhone () {
      this.isBindPhone = true
      this.open = true
    },
    // 处理内嵌iframe的方法
    payFunc () {
      /** 处理内嵌iframe传来的参数 */
      window.addEventListener('message', (e) => {
        if (e.data.dataType === 3 || e.data.dataType === '3') {
          e.data.dataType = Number(e.data.dataType)
          // 进入游戏 存储角色信息
          this.$store.commit('SET_GAMEDATA', e.data)
        }
        // 游戏sdk调起支付框
        if (e.data.type === 'cp_pay') {
          this.payData = e.data
          if (isIOS() && !this.isWeixin && Number(this.$route.query.appleinfo)) {
            const userName = this.status.user_name
            const uid = this.status.user_id
            paySwitch({ game_id: this.init.identity, uid, user_name: userName, money: this.payData.money, productID: this.payData.product_id }).then(res => {
              if (res.data.data.switch === 1) {
                this.iosSwitch = res.data.data.switch
                this.payDialog = true
              } else {
                this.iosSwitch = 3
                this.pay('apple')
              }
            }).catch(() => {
              this.$toast.error('系统繁忙,请重试~')
            })
          } else {
            this.payDialog = true
          }
        }
        // 游戏ID转换处理
        if (e.data.type === 'rebuild_user_info') {
          e.data.appid = this.init.identity
          e.data.type = 'reportUserInfo_web_do'
          window.frames[0].window.postMessage(e.data, '*')
        }
      }, false)
    },
    // 加载游戏
    loadGame () {
      const isHttps = window.location.protocol === 'https:' ? 1 : 0
      const needMainCheck = this.$route.query.pf === 'h5_swap' ? 1 : 0
      const gameUrl = `//${this.theme[this.init.ui_type].apiName}.com/api/h5/inGame.php`
      const appid = this.init.identity || ''
      const uid = this.status.user_id
      const uname = this.status.user_name
      const token = this.token // 换成token
      const agentId = this.$route.query.agent_id || 100000
      const siteId = this.$route.query.site_id || 0
      const imei = this.idfa
      const os = this.$route.query.os || ''
      const model = this.$route.query.model || ''
      const sessionid = this.status.sid || ''
      const idfaiv = this.$route.query.idfv || ''
      const mtype = this.$route.query.mtype || 1
      return `${gameUrl}?appid=${appid}&sub_appid=${appid}&uid=${uid}&uname=${uname}&token=${token}&agent_id=${agentId}&site_id=${siteId}&imei=${imei}&os=${os}&model=${model}&is_https=${isHttps}&need_main_check=${needMainCheck}&sessionid=${sessionid}${isIOS() ? '&idfaiv=' + idfaiv : ''}&mtype=${mtype}`
    },
    switchLoginType (type) { //  切换loginType
      this.loginType = type
      this.visibility = false
      this.loginPhoneForm = this.$options.data().loginPhoneForm
      this.resetForm = this.$options.data().resetForm
      this.loginBoxClick = false
      this.isGetWechatCode = true
      if (type === 'register' && !localStorage.getItem('firstRegister')) {
        this.quickRegister()
      }
      if (type === 'register' && this.init.identity === 885) {
        this.pictureCode = ''
        this.setIdentifyCode()
      }
    },
    // 登陆
    async login (loginType) {
      let obj = {}
      let status = false
      if (loginType === 'ACCOUNT') {
        status = validate([{ val: this.check, msg: '请先阅读用户协议及隐私协议' }, { val: this.loginPhoneForm.username, msg: '账号不能为空' }, { val: this.loginPhoneForm.password, msg: '密码不能为空' }, { val: this.loginPhoneForm.code, options: { id: this.init.identity } }])
        obj = { login_type: loginType, username: this.loginPhoneForm.username, password: this.loginPhoneForm.password }
        if (this.init.identity === 885) {
          obj.wechat_code = this.loginPhoneForm.code
        }
      } else if (loginType === 'WECHAT') {
        status = true
        obj = { login_type: loginType, openid: this.$route.query.wx_openid, phpsessid: this.$route.query.sessionid }
      } else if (loginType === 'AUTH_TOKEN') {
        status = true
        // 防止链接出现两个atk参数
        const atk = typeof this.$route.query.atk === 'object' ? this.$route.query.atk[0] : this.$route.query.atk
        obj = { login_type: loginType, phpsessid: atk, auth_token: atk }
      } else {
        status = validate([{ val: this.check, msg: '请先阅读用户协议及隐私协议' }, { val: this.phoneForm.phone, options: 'phone' }, { val: this.phoneForm.code, msg: '验证码不能为空' }, { val: this.phoneForm.wechat_code, options: { id: this.init.identity } }])
        obj = { login_type: loginType, phone: this.phoneForm.phone, code: this.phoneForm.code }
        if (this.init.identity === 885) {
          obj.wechat_code = this.phoneForm.wechat_code
        }
      }
      if (status) {
        this.adminLoading = true
        let res = await this.$store.dispatch('login', obj)
        this.adminLoading = false
        if (res.error_code) {
          this.$toast.error(res.msg ? res.msg : '请求错误')
          if (loginType === 'AUTH_TOKEN') {
            this.dialogLoginShow()
          }
        } else {
          setToken(res.data.access_token)
          setSession(res.data.session_id)
          this.openSimple = false
          this.$store.commit('SET_TOKEN', res.data.access_token)
          this.$store.commit('SET_SESSION_ID', res.data.session_id)
          this.$toast.success('登录成功')
          this.getStatus()
          // 正常登陆情况记录账号密码
          if (loginType === 'ACCOUNT') {
            this.loginUser(this.loginPhoneForm) //  记录账号密码
          }
          // 微信登陆时执行的方法
          if (loginType === 'WECHAT') {
            if (this.$route.query.wx_appid) {
              localStorage.setItem('wx_appid', this.$route.query.wx_appid)
            }
            this.$router.replace({ path: '/', query: { g_token: this.$route.query.g_token } })
            // 解决ios版本微信端replace不清空敏感信息的bug
            if (isIOS()) {
              setTimeout(function () {
                window.location.href = location.href
              }, 500)
            }
          }
        }
      }
    },
    //  注册
    async getRegister () {
      let status = false
      status = validate([{ val: this.check, msg: '请先阅读用户协议及隐私协议' }, { val: this.loginPhoneForm.username, msg: '账号不能为空' }, { val: this.loginPhoneForm.password, msg: '密码不能为空' }, { val: [this.pictureCode, this.identifyCode], options: 'feCode', id: this.init.identity }])
      if (status) {
        this.registerLoading = true
        const res = await this.$store.dispatch('register', this.loginPhoneForm)
        this.registerLoading = false
        if (!res.error_code) {
          setToken(res.data.access_token)
          setSession(res.data.session_id)
          this.openSimple = false
          this.$store.commit('SET_TOKEN', res.data.access_token)
          this.$store.commit('SET_SESSION_ID', res.data.session_id)
          this.$toast.success('注册成功')
          this.getStatus()
          this.loginUser(this.loginPhoneForm) //  记录账号密码
          localStorage.setItem('firstRegister', true) //  已经注册过的用户，不在提供快捷自动生成账号密码
        } else {
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    //  获取个人信息
    async getInit () {
      const res = await this.$store.dispatch('getInit')
      if (res.error_code) {
        this.$toast.error({ message: res.msg ? res.msg : '请求错误', time: 0 })
      } else {
        if (isWeixin() && this.$route.query.goto === 'getwxoa') {
          const wxOpenid = this.$route.query.wx_openid || this.$route.query.openid || ''
          localStorage.setItem(`${this.init.identity}wxpayoa`, `${wxOpenid} ${this.$route.query.wx_appid}`)
          this.$router.replace({ path: '/', query: { g_token: this.$route.query.g_token } })
          // 解决ios版本微信端replace不清空敏感信息的bug
          if (isIOS()) {
            setTimeout(function () {
              window.location.href = location.href
            }, 500)
          } else {
            location.reload()
          }
          return
        }
        if (!getToken() || getToken() === 'undefined') {
          // isUserLogin (是否账号登陆 有传则账号登陆)
          if (isWeixin() && (this.init.ui_type === 1 || this.init.ui_type === 4 || this.init.ui_type === 5 || (this.init.ui_type === 2 && this.init.identity === 885)) && !this.$route.query.isUserLogin) { //  微信登陆
            this.wxLogin()
          } else { // 账号登陆
            if (this.$route.query.wx_openid && this.$route.query.sessionid) {
              // 扫码登录操作
              this.login('WECHAT')
            } else {
              // 有atk则表示从官网跳转过来执行atk登陆
              if (this.$route.query.atk) {
                this.login('AUTH_TOKEN')
              } else {
                this.dialogLoginShow()
              }
            }
          }
        } else {
          // 有atk则表示从官网跳转过来reload网页执行atk登陆
          if (this.$route.query.atk) {
            removeToken()
            removeSession()
            location.reload()
            return
          }
          this.getStatus()
        }
        // 给特殊游戏增加不熄屏功能
        if (this.init.identity === 3859) {
          const noSleep = new NoSleep()
          document.addEventListener('click', function enableNoSleep () {
            document.removeEventListener('click', enableNoSleep, false)
            noSleep.enable()
          }, false)
        }
        if (isIOS() && this.init.game_info.app_name && this.init.game_info.icon_url) {
          let link = document.createElement('link')
          link.rel = 'apple-touch-icon-precomposed'
          link.href = this.init.game_info.icon_url
          link.sizes = '56*56'
          document.getElementsByTagName('head')[0].appendChild(link)
          let meta = document.createElement('meta')
          meta.name = 'apple-mobile-web-app-title'
          meta.content = this.init.game_info.app_name
          document.getElementsByTagName('head')[0].appendChild(meta)
        }
        // ios添加主屏幕代码
        // 检测是否在QQ并且不在QQ浏览器情况
        if (isQQ()) {
          this.showAli = false
        }
      }
    },
    // 启动弹窗登陆流程
    dialogLoginShow () {
      this.openSimple = true
      this.addUserList()
      // 新登录逻辑
      if (this.init.ui_type !== 3) {
        this.initShow()
      }
      // 优先注册功能
      if (this.init.fast_reg && this.init.ui_type === 3) {
        this.loginType = 'register'
        this.quickRegister()
      }
      // 重置验证码
      if (this.init.identity === 885) {
        this.setIdentifyCode()
      }
    },
    //  获取游戏状态
    async getStatus () {
      const res = await this.$store.dispatch('getStatus')
      if (res.error_code) {
        this.$toast.error(res.msg ? res.msg : '请求错误')
        removeToken()
        removeSession()
        if (this.init.heartbeat_interval >= 60) {
          const gameId = this.init.identity || ''
          const uid = this.status.user_id || ''
          Cookies.remove(`htoken_${gameId}_${uid}`)
        }
        location.reload()
      } else {
        if (isWeixin() && !this.status.openid && !this.$route.query.isUserLogin) {
          // 微信登陆没有openid则强制退出让起使用微信登陆
          removeToken()
          removeSession()
          location.reload()
          return
        }
        if (this.status.bind_phone_status || (this.init.identity !== 885 && this.init.identity !== 521)) {
          if (this.status.bind_phone_status && this.init.identity === 521 && !this.status.certification_status) {
            this.goRealName()
          } else {
            this.gameUrl = this.loadGame()
            this.$refs.game_iframe.onload = () => {
              if (this.init.identity !== 2483 && this.init.identity !== 2599 && this.init.identity !== 3449) {
                this.showLoadingCover = false
              }
            }
          }
        } else {
          this.isBindPhoneOpen = true
          this.goBindPhone()
        }
        if (this.init.heartbeat_interval >= 60) {
          this.hasHeartbeat = true
        }
        this.fullIframe()
        moveDiv(this.$refs.am)
      }
    },
    async getCode (type) { //  获取验证码
      if ((type === 'reset' && this.resetDisabled) || (type !== 'reset' && this.codeDisabled)) {
        return
      }
      var res
      let status = false
      let phone = type === 'reset' ? this.resetForm.phone : this.phoneForm.phone
      status = validate([{ val: phone, options: 'phone' }])
      if (status) {
        if (type === 'reset') {
          this.resetDisabled = true
          this.resetCodeTime = 60
          res = await newPromise(sendSms, { type: 'FORGET_PASSWORD', phone: this.resetForm.phone.trim() })
        } else {
          this.codeDisabled = true
          this.codeTime = 60
          res = await newPromise(sendSms915, { type: 'LOGIN', phone: this.phoneForm.phone.trim() })
        }
        if (!res.error_code) {
          this.$toast.success('发送成功')
        } else {
          this.codeDisabled = false
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    async resetSubmit () { //  重置密码
      let status = false
      status = validate([{ val: this.resetForm.username, msg: '用户名不能为空' }, { val: this.resetForm.phone, options: 'phone' }, { val: this.resetForm.code, msg: '验证码不能为空' }, { val: this.resetForm.password, msg: '密码不能为空' }, { val: [this.resetForm.password, this.resetForm.password_confirmation], options: 'same' }])
      if (status) {
        this.resetLoading = true
        const res = await newPromise(resetPassword, this.resetForm)
        this.resetLoading = false
        if (!res.error_code) {
          this.$toast.success('重置成功')
          this.switchLoginType('user')
        } else {
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    async quickRegister () { //  一键注册
      if (this.qsLoading) {
        return
      }
      this.qsLoading = true
      const res = await newPromise(getRegisterAccount)
      this.qsLoading = false
      if (!res.error_code) {
        this.visibility = true
        this.loginPhoneForm = res.data
      } else {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      }
    },
    userContentCheck () { //  选择用户协议内容
      this.openFullscreen = true
      this.userContent = (this.init.ui_type === 1 || this.init.ui_type === 4) ? twContent : content
    },
    goWx () {
      // 跳转到微信扫码登录
      const appid = this.init.identity || ''
      const agentId = this.$route.query.agent_id || 100000
      const url = `${encodeURIComponent(window.location.origin + urlPath + '?g_token=' + this.$route.query.g_token)}`
      window.location.href = `//${this.theme[this.init.ui_type].apiName}.com/api/wxlogin/?open=newwindow&game_id=${appid}&agent_id=${agentId}&placeid=${agentId}&goto_url=${url}`
    },
    // 支付方法
    pay (type) {
      // 趣通
      if (this.init.ui_type === 3) {
        this.payQuTong(type)
      } else {
        this.tanwanPay(type)
      }
    },
    // 贪玩或695716支付
    tanwanPay (type) {
      if (type === 'wx') { this.payName = '微信' } else { this.payName = '支付宝' }
      const payNcStr = this.init.pay_nc || 0 //  不含支付信息时，值为1,默认0
      const payNative = this.init.pay_native || 0 //  使用原始支付链接时，拉起支付接口需添加pay_native参数，值为1,默认0
      const payType = isMobile(type) ? type + 'Wap' : type + 'Qr'
      const imei = this.idfa
      const os = this.$route.query.os || ''
      const model = this.$route.query.model || ''
      const userName = this.status.user_name
      const uid = this.status.user_id
      const gameId = this.init.identity
      const pageFrom = this.$route.query.pf || '' //  pf
      const agentId = this.$route.query.agent_id || 100000
      const siteId = this.$route.query.site_id || 100000
      const channelID = 1
      this.payLoading = true
      if (isIOS()) {
        this.payData.idfaiv = this.$route.query.idfv || ''
      }
      if (isIOS() && type === 'apple') {
        payApple(Object.assign({}, this.payData, { imei, os, model, userID: uid, userName, appID: gameId, pay_native: payNative, pay_nc: payNcStr, return_url: window.location.href, agent_id: agentId, site_id: siteId, channelID }, {
          productID: this.payData.product_id,
          productName: this.payData.product_name,
          productDesc: this.payData.product_desc,
          extension: this.payData.ext,
          roleID: this.payData.role_id,
          roleName: this.payData.role_name,
          serverID: this.payData.server_id,
          serverName: this.payData.server_name
        })).then(res => {
          this.payLoading = false
          if (res.data.ret === 1) {
            h5IosWapSdk.payApple(Object.assign(res.data, { server_name: this.payData.server_name, role_id: this.payData.role_id, user_name: userName, user_id: uid }))
            this.payDialog = false
          } else {
            this.$toast.error(res.data.msg)
          }
        }).catch(() => {
          this.$toast.error('支付失败')
          this.payLoading = false
        })
        return
      }
      if (type === 'wx') {
        if (isWeixin()) {
          let wxOpenid = ''
          let wxAppid = ''
          let callbackUrl = `${encodeURIComponent(window.location.origin + urlPath + '?g_token=' + this.$route.query.g_token + '&goto=getwxoa')}`
          if (localStorage.getItem(`${this.init.identity}wxpayoa`)) {
            [wxOpenid, wxAppid] = localStorage.getItem(`${this.init.identity}wxpayoa`).split(' ')
          } else {
            wxOpenid = this.status.openid
            wxAppid = localStorage.getItem('wx_appid')
          }
          wftWxJsPay(Object.assign({}, this.payData, { uid, user_name: userName, game_id: gameId, wx_openid: wxOpenid, agent_id: agentId, site_id: siteId, wx_appid: wxAppid || '', callback_url: callbackUrl })).then(res => {
            this.payLoading = false
            if (res.data.status === 200) {
              try {
                const payInfo = JSON.parse(res.data.data.pay_info)
                wx.wxJsPay(payInfo, this)
              } catch {
                window.location.href = res.data.data.pay_info
              }
            }
            if (res.data.status === 302) {
              window.location.href = res.data.data.auth_url
            }
            if (res.data.status === 303) {
              window.location.href = res.data.data.url
            }
            if (res.data.status === 401) {
              this.showTips = true
              this.msge = res.data.msg
              this.closePay()
            }
          }).catch(() => {
            this.$toast.error('支付失败')
            this.payLoading = false
          })
          return
        }
      }
      pay(Object.assign({}, this.payData, { imei, os, model, uid, pay_type: payType, user_name: userName, game_id: gameId, pay_native: payNative, pay_nc: payNcStr, return_url: window.location.href, agent_id: agentId, site_id: siteId })).then(res => {
        this.payLoading = false
        if (res.data.status === 200) {
          // 交换包
          if (h5IosWapSdk.chkFrom(pageFrom)) {
            h5IosWapSdk.pay(res.data.data.pay_url)
            this.payDialog = false
            return
          }
          this.pay_url = res.data.data.pay_url
          if (isMobile(type)) {
            setTimeout(() => {
              // 解决支付后回来没有关闭浮窗问题
              this.closePay()
            }, 5000)
            const payUrl = res.data.data.pay_url.replace(/&amp;/g, '&')
            if (this.init.pay_type === 'IFRAME') {
              this.payUrl = payUrl
            } else {
              // 安卓浏览器打开新页面
              if (!isIOS() && payNative === 1 && !isWeixin()) {
                var newWindow = window.open('about:blank')
                newWindow.location = res.data.data.normal_url.replace(/&amp;/g, '&')
              } else {
                window.location.href = payUrl
              }
            }
          } else {
            this.code_img_url = res.data.data.code_img_url
            this.order_id = res.data.data.order_id
            setTimeout(() => {
              // 查询订单
              this.orderCount++
              this.checkOrder({ orderid: this.order_id })
            }, 3000)
          }
        } else {
          this.$toast.error(res.data.msg)
          if (res.data.ret === 0 && res.data.playero === 'dialog') {
            this.rechargeObj = Object.assign({}, res.data.data, { show: 1 })
            this.closePay()
          }
        }
      }).catch(() => {
        this.payLoading = false
      })
    },
    // 趣通支付
    payQuTong (type) {
      let promiseFunc
      if (type === 'wx') {
        this.payName = '微信'
        promiseFunc = qutongWXPay
      } else {
        this.payName = '支付宝'
        promiseFunc = qutongAliPay
      }
      this.payLoading = true
      const obj = {
        appid: this.init.identity || 0,
        uid: this.status.user_id,
        user_name: this.status.user_name,
        money: this.payData.money,
        role_id: this.payData.role_id,
        role_name: this.payData.role_name,
        server_id: this.payData.server_id,
        server_name: this.payData.server_name,
        product_id: this.payData.product_id,
        product_name: this.payData.product_name,
        product_desc: this.payData.product_desc,
        ext: this.payData.ext
      }
      promiseFunc(obj).then(res => {
        this.payLoading = false
        if (res.data.status !== 200) {
          this.$toast.error(res.data.message)
          return
        }
        setTimeout(() => {
          // 解决支付后回来没有关闭浮窗问题
          this.closePay()
        }, 5000)
        window.location.href = res.data.info.pay_url
      }).catch(e => {
        this.payLoading = false
        this.$toast.error('请求错误')
      })
    },
    // 判断订单是否完成
    checkOrder (params) {
      if (this.payDialog) {
        checkOrder(params).then(res => {
          if (this.orderCount <= 39) {
            if (res.data.data.ret === 1) {
              this.$toast.success('支付成功')
              this.closePay()
            } else {
            // 继续查询
              setTimeout(() => {
                this.orderCount++
                this.checkOrder(params)
              }, 3000)
            }
          } else {
            this.$toast.error('支付超时,请重新下单')
            this.closePay()
          }
        }).catch(() => {})
      }
    },
    // 关闭支付
    closePay () {
      this.payDialog = false
      this.code_img_url = ''
      this.pay_url = ''
      this.order_id = ''
      this.orderCount = 0
      this.payUrl = ''
    },
    // 登记账号
    loginUser (obj) {
      if (localStorage.getItem('userList')) {
        const arr = JSON.parse(localStorage.getItem('userList'))
        if (!arr.some(v => { return v.username === obj.username })) {
          arr.length > 9 && arr.shift()
          arr.push(obj)
          localStorage.setItem('userList', JSON.stringify(arr))
        } else {
          arr.forEach(v => {
            if (v.username === obj.username) {
              v.username = obj.username
              v.password = obj.password
            }
          })
          localStorage.setItem('userList', JSON.stringify(arr))
        }
      } else {
        const arr = [obj]
        localStorage.setItem('userList', JSON.stringify(arr))
      }
    },
    // 选择账号
    selectUser (val, item) {
      for (const item of this.userList) {
        if (item.username === val) {
          this.loginPhoneForm.username = item.username
          this.loginPhoneForm.password = item.password
          this.loginBoxClick = false
        }
      }
    },
    // 获取user的列表
    addUserList () {
      if (localStorage.getItem('userList')) {
        this.userList = JSON.parse(localStorage.getItem('userList'))
        this.userInputList = this.userList.map(v => v.username)
      }
    },
    // 删除用户
    cleanUser (item, index) {
      this.userList.splice(index, 1)
      this.userInputList = this.userList.map(v => v.username)
      localStorage.setItem('userList', JSON.stringify(this.userList))
      if (this.loginPhoneForm.username === item) {
        this.loginPhoneForm = this.$options.data().loginPhoneForm
      }
    },
    isIOSBangs () {
      return isIOSBangs()
    },
    // 获取微信验证码
    async getWechatCode (type) {
      if (this.isGetWechatCode) {
        const status = validate([{ val: type === 'user' ? this.loginPhoneForm.username : this.phoneForm.phone, msg: '账号不能为空' }])
        if (status) {
          this.isGetWechatCode = false
          const res = await getWechatCode({ username: type === 'user' ? this.loginPhoneForm.username : this.phoneForm.phone })
          if (res.data.error_code) {
            this.isGetWechatCode = true
            this.$toast.error(res.data.msg)
            if (res.data.error_code === 2025 || res.data.error_code === 2030) {
              this.openWxQrCode = true
            }
          } else {
            this.$toast.success('发送验证码成功')
          }
        }
      }
    },
    // 重新设置验证码
    setIdentifyCode () {
      this.identifyCode = ''
      this.identifyCode = Math.random().toString(36).substr(2, 4)
    },
    // 开启游戏
    setGameUrl () {
      if (!this.gameUrl) {
        this.gameUrl = this.loadGame()
        this.$refs.game_iframe.onload = () => {
          if (this.init.identity !== 2483 && this.init.identity !== 2599 && this.init.identity !== 3449) {
            this.showLoadingCover = false
          }
        }
      }
    },
    async heartbeatFunc (val) {
      if (val === 'realName') {
        this.goRealNameRoute = true
        this.open = true
        // 跳转到实名认证
        setTimeout(() => {
          this.goRealNameRoute = false
        }, 100)
      }
      if (val === 'closeGame') {
        this.gameUrl = ''
        this.showLoadingCover = true
      }
    },
    // 关闭心跳浮窗
    closeHeartbeatWindow () {
      if (this.init.heartbeat_interval >= 60) {
        this.$refs.heartbeat.closeIsHeartBeat()
      }
    },
    // 检测ios是否开启无痕浏览
    checkIosTraceless () {
      var storage = window.sessionStorage
      try {
        storage.setItem('testIos', 'test')
        storage.removeItem('testIos')
        return true
      } catch (error) {
        alert('为了您的游戏体验，请不要在无痕模式下访问，否则账号自动登录等功能将无法正常使用。')
      }
    },
    closeOpen () {
      this.open = false
    }
  }
}
</script>

<style lang="less" scoped>
.mu-input {
  font-size: 14px;
  margin-bottom: 2px;
}
.mu-drawer {
  max-width: 400px; //  兼容pc端
}
.tar {
  text-align: right;
  overflow: hidden;
  font-size: 12px;
  line-height: 24px;
}
.reset {
  float: left;
  color: #333;
}
.back {
  color: #333;
  float: left;
  position: relative;
  z-index: 2;
}
.tips {
  font-size: 12px;
  line-height: 30px;
  color: #888;
  text-align: center;
}
.fast-login {
  margin-top: 20px;
  text-align: center;
  .title {
    border-top: 1px solid #e8e8e8;
    margin-top: 20px;
    line-height: 20px;
    text-align: center;
    span {
      position: relative;
      top: -11px;
      padding: 0 10px;
      background-color: #FFF;
      color: #999;
      font-size: 14px;
    }
  }
}
.mu-text-field {
  font-size: 14px;
}
.flex {
  display: flex;
  justify-content: center;
}
.flex-item {
  padding: 8px 0;
  margin: 0 10px;
  font-size: 16px;
  position: relative;
  display: flex;
  cursor: pointer;
  .icon-box {
    width: 25px;
    height: 25px;
    border-radius: 80%;
    background: #C2C2C2;
    img {
      display: block;
      width: 100%;
    }
  }
  .flex-title {
    line-height: 25px;
    margin-left: 10px;
    color: #999;
  }
}
.dl-title {
  font-size: 20px;
  color: #333;
  width: 100%;
  font-weight: 600;
  text-align: center;
  position: relative;
  .back-icon {
    font-size: .56rem;
    color: #CCCBCA;
    position: absolute;
    left: 4px;
    top: 3px;
  }
}
.check-box {
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  padding-bottom: .12rem;
  .mu-checkbox {
    vertical-align: text-bottom;
  }
  .check-p {
    color: #666;
    vertical-align: super;
    margin-left: .1rem;
  }
}
.h5-game-iframe {
  position: relative;
  display: block;
  z-index: 1;
  overflow:hidden;
  margin: 0 auto;
}
.h5-loading-cover {
  display: none;
  position: absolute;
  z-index: -2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  text-align: center;
  background: #1e1e1e center;
  overflow: hidden;
  img {
    display: block;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
.am-btn {
  width: 50px;
  height: 50px;
  position: fixed;
  top: 65%;
  left: 84%;
  white-space: nowrap;
  z-index: 9999990;
  animation: Twinkle 1s infinite alternate linear;
  img {
    display: block;
    width: 100%;
  }
  .qiwanwansdk_fuli {
    font-size: 12px;
    font-style: normal;
    border-radius: 8px;
    padding-left: 5px;
    padding-right: 5px;
    color: white;
    background-color: #FF7171;
    position: relative;
    bottom: 60px;
    right: -22px;
  }
}
.user-content {
  padding: .1rem .3rem .2rem;
}
.dl-content {
  font-size: .2rem;
  color: #333;
  line-height: .36rem;
  letter-spacing: .06rem;
  .dl-c-title {
    padding-bottom: .2rem;
    font-size: .26rem;
    font-weight: 800;
  }
}
.dl-footer {
  display: flex;
  justify-content: space-between;
}
.dia-content-box {
  position: relative;
}
// 隐藏的iframe
.window_iframe {
  display: none;
}
.dialog-box {
  position: relative;
  .title-box {
    position: absolute;
    top: -22px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    .dl-title {
      font-size: .26rem;
      color: #57534E;
      text-align: center;
      width: 100%;
      padding: .3rem 0;
    }
    .close {
      position: absolute;
      right: -10px;
      top: 12px;
      font-size: .5rem;
      color: #CCCBCA;
    }
  }
  .dl-cont {
    padding-top: .6rem;
    text-align: center;
    padding-bottom: .3rem;
    .dl-c-title {
      font-size: .22rem;
      color: #6884F1;
      line-height: .3rem;
      padding-bottom: .22rem;
      span {
        color: #57534E;
        margin-left: .1rem;
      }
    }
    .money {
      font-size: .5rem;
      color: #FF9307;
      padding-bottom: .22rem;
    }
    .money-name {
      font-size: .22rem;
      color: #57534E;
    }
  }
  .dl-bot {
    .dl-b-title {
      color: #B5B5B5;
      font-size: .2rem;
      text-align: center;
      position: relative;
      margin-bottom: .16rem;
      .line {
        height: 1px;
        background: #E0E0E0;
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        z-index: 1;
      }
      span {
        position: relative;
        z-index: 2;
        background: #fff;
        padding: 0 .2rem;
      }
    }
    .btn-box {
      display: flex;
      justify-content: center;
      .btn {
        margin: 0 .4rem;
      }
    }
  }
  .pc {
    text-align: center;
    display: block;
    overflow: hidden;
    .pc-img-box {
      width: 2.3rem;
      height: 2.3rem;
      margin: .8rem auto .2rem auto;
      img {
        display: block;
        width: 100%;
      }
    }
    .pc-title {
      font-size: .22rem;
      line-height: .36rem;
      color: #57534E;
      span {
        color: #FFA800;
        font-size: .3rem;
        margin: 0 .04rem;
      }
    }
    .pc-a {
      text-decoration:underline;
      font-size: .22rem;
      color: #6884F1;
      line-height: .36rem;
    }
  }
}
.home { //  强行更改组件不合理样式
  /deep/ .mu-tab {
    min-width: auto;
  }
}
// 横屏css
.horizontal {
  /deep/ .sub-header {
    .logo {
      display: none;
    }
  }
  /deep/ .nav {
    display: none;
  }
  /deep/ .flex-content {
    .nav_h {
      display: block;
    }
  }
}
// 安全边界css
.safe-content {
  background: #000;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  box-sizing: border-box;
  /deep/ .mu-drawer {
    left: env(safe-area-inset-left);
  }
}
.mb20 {
  margin-bottom: .2rem;
}
// 新版登陆界面样式
.new-login {
  /deep/ .mu-dialog {
    border-radius: .28rem;
  }
  /deep/ .mu-dialog-body {
    padding: 0;
  }
  .l-title {
    font-size: 0.4rem;
    text-align: center;
    padding: 0.34rem 0;
    position: relative;
    .back {
      position: absolute;
      top: .45rem;
      left: .24rem;
      width: .38rem;
      height: .38rem;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .l-input {
    width: 91.5%;
    height: 0.72rem;
    border-radius: 0.08rem;
    background:rgba(248,246,249,1);
    margin: 0 auto 0.24rem auto;
    position: relative;
    .i-title {
      width: 24%;
      float: left;
      font-size: 0.28rem;
      color: #272727;
      line-height: 0.72rem;
      padding-left: 0.28rem;
      box-sizing: border-box;
    }
    .input-box {
      width: 65%;
      float: left;
      font-size: 0.28rem;
      color: #272727;
      background:rgba(248,246,249,1);
      line-height: 0.72rem;
      padding: 0;
    }
    .input-code {
      width: 40%;
    }
    .get-code {
      width: 36%;
      float: right;
      font-size: .28rem;
      color: #9C262C;
      text-align: center;
      line-height: .72rem;
    }
    .picture-box {
      width: 36%;
      float: right;
      height: .72rem;
      position: relative;
    }
    .select-icon {
      float: right;
      width: 11%;
      height: 100%;
      position: relative;
      img {
        position: absolute;
        display: block;
        width: 35%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transition: all .3s ease;
      }
      .icon-box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        text-align: center;
        line-height: .72rem;
      }
    }
    &::after {
      content: '';
      display: block;
      clear: both;
    }
    input {
      border: 0;
      &:focus {
        outline: none;
      }
    }
    .select-list {
      display: none;
      width: 100%;
      max-height: 2.25rem;
      overflow: scroll;
      position: absolute;
      top: .72rem;
      left: 0;
      z-index: 2;
      .item {
        height: 0.72rem;
        width: 100%;
        background:rgba(248,246,249,1);
        border-top: 1px solid #fff;
        .p {
          width: 88%;
          display: block;
          float: left;
          padding-left: .29rem;
          line-height: .72rem;
          font-size: .28rem;
          color: #272727;
        }
        .clean {
          width: 12%;
          height: 100%;
          float: right;
          position: relative;
          z-index: 2;
          img {
            position: absolute;
            display: block;
            width: 40%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          }
        }
      }
    }
  }
  .selcet-input {
    .select-list {
      display: block;
    }
    .select-icon {
      img {
        transform: rotateZ(180deg);
        transition: all .3s ease;
      }
    }
  }
  .l-tips {
    text-align: center;
    line-height: 0.44rem;
    overflow: hidden;
    .l-img {
      width: 0.28rem;
      height: 0.28rem;
      display: inline-block;
      padding: 0.08rem;
      box-sizing: content-box;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .tips-left {
      margin-left: .24rem;
      float: left;
    }
    .lose-pwd {
      float: right;
      margin-right: .24rem;
      color: #56181B;
      font-size: .28rem;
    }
    .p {
      height: 0.44rem;
      vertical-align: super;
      font-size: 0.28rem;
      color: #454545;
      a {
        text-decoration:underline;
        color: #9C262C;
        padding-left: 0.08rem;
      }
    }
  }
  .l-button {
    margin: 0.2rem 0.26rem 0.3rem 0.26rem;
    text-align: center;
    height: 0.8rem;
    border-radius: 0.08rem;
    color: #fff;
    line-height: 0.8rem;
    font-size: 0.35rem;
    position: relative;
  }
  .l-bot {
    padding: 0 0.47rem 0.4rem 0.47rem;
    font-size: 0.28rem;
    color: #454545;
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}

@media screen and (max-width:450px) {
  @f20: .2rem;
  @f26: .26rem;
  @f18: .18rem;
  .mu-input, .flex-item {
    font-size: @f20;
  }
  .dl-title {
    font-size: .36rem;
  }
  .code, .tar, .check-box, .tips {
    font-size: @f18;
  }
}
* { touch-action: pan-y; }  //  解决拖动时的报错提示

@keyframes Twinkle {
  0%{
    opacity: .5;
  }
  100% {
    opacity: .9;
  }
}

.bangsTop {
  margin-top: 34px;
}

.wx-img-box {
  width: 100%;
  position: relative;
  padding: .2rem 0 .2rem 0;
  .wx-qrcode {
    width: 2.58rem;
    display: block;
    margin: 0 auto .1rem auto;
  }
  .wx-tips {
    font-size: .24rem;
    color: #333;
    text-align: center;
    padding-bottom: .1rem;
  }
}

.mudia {
  /deep/ .mu-dialog-body {
    padding: 0;
  }
  /deep/ .mu-dialog {
    border-radius: .14rem;
    overflow: hidden;
  }
  /deep/ .mu-tab {
    font-size: 12px;
  }
}
</style>
